import CustomViewDialogStore from "csi/middleware/customView/CustomViewDialogStore";
import CustomViewController from "csi/view/CustomViewController";
import { ILocaleProvider } from "designSystem/locale";
import declare from "dojo/_base/declare";
import { TableWidget } from "./Widget";
import { createAttributesStore } from "csi/service/viewService";

const TableCustomViewController = declare(CustomViewController, {
	/**
	 * @override
	 * Populate the stores available for table views
	 */
	onCreateStore(loc: ILocaleProvider, store: CustomViewDialogStore): void {
		const { widget } = this;
		const tableWidget = widget as TableWidget;
		store.allowSuspendPreview = tableWidget.suspendIsOption || tableWidget.suspended || tableWidget.allowSuspendInCustomViewPreview;
		store.attributesStore = createAttributesStore(widget, loc);
		store.dataManagementStore = this._createDataManagementStore(loc, store.attributesStore);
	},
});

export = TableCustomViewController;